import React, { useEffect, useRef, useState } from "react";
import {
  Backdrop, Box, Button, CircularProgress, Grid, List, SwipeableDrawer, TablePagination,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@material-ui/core";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import Notification from "../../components/Notification";
import "../../tag_status.css"
// components
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardMedia";
import CloseIcon from "@material-ui/icons/Close";
import PageTitle from "../../components/PageTitle";
import GetAppIcon from "@material-ui/icons/GetApp";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import gold_coin from "../../images/svg/Gold-coin.svg"
// data
import Tooltip from "@material-ui/core/Tooltip";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import useStyles from "../../themes/style.js";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { jwtDecode } from "jwt-decode";
import CustomPdfView from "../../components/pdfViewer/CustomPdfView.js";
import { getFileExtension } from "../../utils/getextension.js";
import { useFLInvoiceDataContext } from "../../context/FreelancerInvoiceDataContext.js";
import { useHistory } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import Lottie from 'lottie-react'
import SuccessMsg from "../../images/lootie/success.json"
import ErrorMsg from "../../images/lootie/failure.json"
import WarningMsg from "../../images/lootie/warning.json"


const AlertMessagePopup = ({ alertOpen, handleAlertClose, alertTitle, alertMessage, alertImage }) => {
  const classes = useStyles();

  return (
    <Dialog
      aria-labelledby="dialog-title"
      open={alertOpen}
      width="md"
      PaperProps={{
        style: {
          width: "100%",
        },
      }}
    >
      <DialogTitle>
        <div className={classes.center} style={{ paddingTop: "15px" }}>
          <Typography style={{ fontSize: "1.3rem", fontWeight: 500 }}>
            {alertTitle}
          </Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className={classes.center}>
          <Lottie
            style={{ width: '100px' }}
            animationData={alertImage}
            loop={true}
            autoplay={true}
          />
        </div>
        <Typography variant="body1" className={classes.center}>
          {alertMessage}
        </Typography>

        <Grid className={classes.sendWhatsapp}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={(e) => {
              handleAlertClose()
            }}
          >
            Done
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}


const positions = [toast.POSITION.TOP_RIGHT];
export default function ClaimCoins() {

  const classes = useStyles();
  const mobileQuery = useMediaQuery('(max-width:600px)');
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token)
  const history = useHistory()
  const { setInvoiceItemData } = useFLInvoiceDataContext()
  const [overAllCheckedValue, setOverAllCheckedValue] = useState(0);
  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [requirementsData, setRequirementsData] = useState([]);
  const [requirementsView, setRequirementsView] = useState({
    id: "",
    requirementName: "",
    clientId: "",
    skills: "",
    orgRecruiterId: "",
    orgRecruiterName: "",
    jobLocation: "",
    experience: "",
    uniqueId: "",
    clientUniqueId: "",
    clientName: "",
    gist: "",
    jd: "",
    status: "",
    createdAt: "",
  });
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState(null);
  const [alertImage, setAlertImage] = useState(null);

  const showAlert = (title, message, image) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertImage(image);
    setAlertOpen(true);
  };

  const handleAlertClose = () => {
    setAlertOpen(false)
  }

  const notify = (type, customMessage,) => {
    switch (type) {
      case 'success':
        showAlert('Success', customMessage, SuccessMsg);
        break;
      case 'error':
        showAlert('Error', customMessage, ErrorMsg);
        break;
      case 'warning':
        showAlert('Warning', customMessage, WarningMsg);
        break;
      default:
        break;
    }
  };
  var [errorToastId, setErrorToastId] = useState(null);
  var [notificationsPosition] = useState(2);


  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }

  function handleNotificationCall(notificationType, message) {
    var componentProps;
    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[notificationsPosition],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }


  const resumeUrl = requirementsView?.jd;
  const fileExtension = resumeUrl ? getFileExtension(resumeUrl) : null;

  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [modalOpen, setModalOpen] = React.useState(false);

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}recruiter/getMyCreditsHistory`,
        data: {
          page: 1,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {

        if (response.data.status === true) {
          setLoader(false);

          setRequirementsData(response.data.data);
          setCount(response.data.count);
        }
      }).catch((error)=>{
        console.log(error)
      });
    };
    fetchData();
  }, [token]);


  const filterRef = useRef(null);

  const [checkedIds, setCheckedIds] = useState([]);

  const handleCheckboxChange = (record, item, isChecked) => {
    const currentDate = moment();
    const createdDate = moment(record?.createdAt).startOf('day');
    const dateDifference = currentDate.diff(createdDate, 'days'); 
    const redeemDate = createdDate.add(30, 'days').format('DD-MM-YYYY');

    if (record?.status === "TO-INVOICE" && record?.reason === 309 && dateDifference >= 30) {
      setCheckedIds(prevCheckedIds => {
        if (isChecked) {
          const updatedCheckedIds = [...prevCheckedIds, { id: record.id, value: record.value }];
          return updatedCheckedIds;
        } else {
          const updatedCheckedIds = prevCheckedIds.filter(checkedItem => checkedItem.id !== record.id);
          return updatedCheckedIds;
        }
      });

      setInvoiceItemData(prevCheckedItems => {
        if (isChecked) {
          return [...prevCheckedItems, { id: record.id, value: record.value }];
        } else {
          return prevCheckedItems.filter(checkedItem => checkedItem.id !== record.id);
        }
      });
    }
    else if (record?.reason !== 309) {
      setCheckedIds(prevCheckedIds => {
        if (isChecked) {
          const updatedCheckedIds = [...prevCheckedIds, { id: record.id, value: record.value }];
          return updatedCheckedIds;
        } else {
          const updatedCheckedIds = prevCheckedIds.filter(checkedItem => checkedItem.id !== record.id);
          return updatedCheckedIds;
        }
      });

      setInvoiceItemData(prevCheckedItems => {
        if (isChecked) {
          return [...prevCheckedItems, { id: record.id, value: record.value }];
        } else {
          return prevCheckedItems.filter(checkedItem => checkedItem.id !== record.id);
        }
      });
    }
    else {
      notify('error',
        <span>
          These RecCoins can be Redeemed only after {redeemDate} which is 30 Days from Joining Date
          <br />
        </span>, ErrorMsg)
      // alert(`No-redeem available ${redeemDate}`);
    }
  };

  function getApprovalStatusColor(status) {
    let className;
    switch (status) {
      case "INVOICED":
        className = "neutral-extrahigh"
        break;
      case "REDEEMED":
        className = "positive-medium"
        break;
      default:
        className = "neutral-extrahigh"
        break;
    }
    return className;
  }

  const blinkIteration = {
    "--iteration-count": "infinite",
  };

  const renderValue = (record, item) => (
    <div style={{ background: 'transparent', borderRadius: '300px', padding: "0.1rem 0.4rem", display: "flex", alignItems: "center", gap: "0.2rem" }}>
      {record?.status === "TO-INVOICE" && (
        <input
          type="checkbox"
          checked={checkedIds.some(checkedItem => checkedItem.id === record.id)}
          style={{ cursor: 'pointer' }}
          onChange={(e) => handleCheckboxChange(record, item, e.target.checked)}
        />
      )}
      <span style={{ color: "#333" }}>{record?.value}</span>
      <br />
      {(record?.status === "INVOICED" || record?.status === "REDEEMED") && (
        <div className={`status-tag ${getApprovalStatusColor(record.status)}`}>
          <i
            className={`highlight ${getApprovalStatusColor(record.status)}`}
            style={blinkIteration}
          ></i>
          <p className='status-tag__txt bac-l-stack-xs' style={{ textTransform: 'capitalize' }}>{record.status}</p>
        </div>
      )}
    </div>
  );

  const calculateTotalEarnings = (item) => {
    const checkedEarnings = checkedIds
      .filter(checkedItem => item.recordsValues.some(record => record.id === checkedItem.id))
      .reduce((sum, checkedItem) => sum + checkedItem.value, 0);

    return checkedEarnings;
  };

  // const calculateOverallCheckedValue = () => {
  //   return checkedIds.reduce((sum, item) => sum + item.value, 0);
  // };



  useEffect(() => {
    const calculateOverallCheckedValue = () => {
      return checkedIds.reduce((sum, item) => sum + item.value, 0);
    };

    const overallValue = calculateOverallCheckedValue();
    setOverAllCheckedValue(overallValue);
  }, [checkedIds]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCurrerntPage(newPage + 1);
    setLoader(true);

    const form = filterRef.current;
    var data = JSON.stringify({
      page: newPage + 1,
      fromDate: `${form["fromDate"].value}`,
      toDate: `${form["toDate"].value}`,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/getMyCreditsHistory`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setRequirementsData(response.data.data);
        setCount(response.data.count);
        setLoader(false);
      }

      setLoader(false);
    }).catch((error)=>{
      handleNotificationCall("error",error)
      console.log(error)
    });
  };


  const [state, setState] = useState({
    right: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  const HeaderElements = () => (
    <>
      <Grid className={classes.HeaderElements}>
        Total : {count}
      </Grid>
    </>
  );
  const handleClaimCoins = () => {
    const isBankDetails = localStorage.getItem("isBankDetailsAvailable")
    const isBankDetailsEmpty = JSON.parse(isBankDetails)
    if (isBankDetailsEmpty === false) {
      notify('error',
        <span> Please Fill Your Bank Details Before Redeeming Your Rec-Coins <br />
          <span> <a onClick={() => history.push("/app/bank_details")} style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}> Click Here</a> to go bank details </span>
        </span>, ErrorMsg)
      return
    }

    if (overAllCheckedValue < 100) {
      notify('error', 'Minimum 100 RecCoins needed to Redeem', ErrorMsg)
      return
    }
    const checkedData = requirementsData
      .map(requirement => {
        const updatedRecordsValues = requirement.recordsValues.map(record => {
          const isChecked = checkedIds.some(checkedItem => checkedItem.id === record.id);
          return { ...record, checked: isChecked };
        });

        const hasCheckedRecord = updatedRecordsValues.some(record => record.checked);

        if (hasCheckedRecord) {
          return { ...requirement, recordsValues: updatedRecordsValues };
        } else {
          return null;
        }
      })
      .filter(requirement => requirement !== null);

    setInvoiceItemData(checkedData);
    history.push("freelancer_invoice");
  };

  const list = (anchor) =>
  (
    <Box sx={{ width: "100%" }} role="presentation">
      <List>
        <Card className={classes.root}>
          <CardHeader>
            <Grid
              container
              direction="row"
              spacing={1}
              className={classes.drawerViewHeader}
            >
              <Grid item xs={10} md={6}>
                <Typography variant="subtitle1">
                  View Requirement - {requirementsView.requirementName}
                </Typography>
              </Grid>

              <Grid item xs={2} lg={6} className={classes.drawerViewClose}>
                <CloseIcon
                  className={classes.closeBtn}
                  size="14px"
                  onClick={toggleDrawer(anchor, false)}
                />
              </Grid>
            </Grid>
          </CardHeader>

          <CardContent className={classes.drawerViewContent}>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={6}>

                <Typography className={classes.boldtext}>

                  Requirement Name:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>

                {requirementsView.requirementName +
                  " (" +
                  requirementsView.uniqueId +
                  ") "}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>

                <Typography className={classes.boldtext}>
                  {decode.companyType === "COMPANY" ? "Project Name:" : "Client Name:"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>

                {requirementsView.clientName +
                  " (" +
                  requirementsView.clientUniqueId +
                  ") "}
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>

                <Typography className={classes.boldtext}>

                  Experience:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>

                {requirementsView.experience}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>

                <Typography className={classes.boldtext}>

                  Skills:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>

                {requirementsView.skills}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>

                <Typography className={classes.boldtext}>

                  Location:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>

                {requirementsView.jobLocation}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>

                <Typography className={classes.boldtext}>

                  JD :
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>

                <div className={classes.space + " " + classes.alignItemsEnd}  >


                  {requirementsView?.jd !== `${process.env.REACT_APP_AWS_BUCKET_URL}` ? <>
                    <Tooltip
                      title="View JD"
                      placement="bottom"
                      aria-label="view"
                    >
                      <RemoveRedEyeIcon
                        className={classes.toolIcon}
                        onClick={handleModalOpen}
                      />
                    </Tooltip>

                    <Tooltip
                      title="Downlaod JD"
                      placement="bottom"
                      aria-label="downlaod"
                    >
                      <a className={classes.messageContent} href={requirementsView?.jd} download>

                        <GetAppIcon className={classes.toolIcon} />
                      </a>
                    </Tooltip>
                  </> : ""}
                </div>

              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Requirement Gist:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>

                <div dangerouslySetInnerHTML={{ __html: requirementsView.gist }}></div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>

                <Typography className={classes.boldtext}>

                  Status:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {requirementsView.status ? (
                  requirementsView.status.statusName === "ACTIVE" ? (
                    <>
                      <Button
                        variant="contained"
                        size="small"
                        className={classes.green + " " + classes.noPointer}
                      >
                        ACTIVE
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="contained"
                        size="small"
                        className={classes.red + " " + classes.noPointer}
                      >
                        INACTIVE
                      </Button>
                    </>
                  )
                ) : (
                  ""
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>

                <Typography className={classes.boldtext}>

                  Posted Date:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>

                {moment(requirementsView.createdAt).format(
                  "DD-MM-YYYY",
                )}
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Grid
              container
              direction="row"
              spacing={2}
              className={classes.drawerFooter}
            >
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={toggleDrawer(anchor, false)}
              >
                Close
              </Button>
            </Grid>
          </CardActions>
        </Card>
      </List>
    </Box>

  );

  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Earned Coins" />
        </Grid>

        <Grid item xs={3} sm={5} md={4} lg={6} className={classes.drawerClose}>
          <SwipeableDrawer
            anchor="right"
            open={state["right"]}
            onClose={toggleDrawer("right", false)}
            onOpen={toggleDrawer("right", true)}
            classes={{ paper: classes.drawer }}
          >
            {list("right")}
          </SwipeableDrawer>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MUIDataTable
            title=""
            options={{
              pagination: false,
              sort: false,
              search: false,
              filter: false,
              download: false,
              print: false,
              viewColumns: true,
              selectableRows: "none",
              customToolbar: () => <HeaderElements />,

              responsive: mobileQuery === true ? 'vertical' : 'standard',
              // onRowSelectionChange: handleRowsSelect,
              textLabels: {
                body: {
                  noMatch: 'Oops! Matching record could not be found',
                }
              },
            }}
            columns={[
              {
                name: "S.No",
              },
              {
                name: "Candidate Name",
              },
              {
                name: "Requirement Name",
              },
              {
                name: "RecCoin per CV Share",
              },
              {
                name: "RecCoin per Final Interview Turn-up",
              },
              {
                name: "RecCoin per Candidate Hired",
              },

              {
                name: "Total Earnings",
              },
            ]}
            data={requirementsData && requirementsData.map((item, index) => {

              const cvShareValue = item.recordsValues.find(record => record.reason === 303);
              const cvInterviewValue = item.recordsValues.find(record => record.reason === 307);
              const cvHiredValue = item.recordsValues.find(record => record.reason === 309);

              return [
                <>
                  {currerntPage !== 0 ? 10 * currerntPage - 10 + index + 1 : index + 1}
                </>,
                <>
                  {item.candidate?.candidateDetail.firstName} {"(" + item.candidate?.candidateDetail.lastName + ")"} <br /> {"(" + item.candidate?.uniqueId + ")"}
                </>,
                <>{item.requirement?.requirementName + " (" + item.requirement?.uniqueId + ")"}</>,
                renderValue(cvShareValue),
                renderValue(cvInterviewValue),
                renderValue(cvHiredValue),
                <div key={index} style={{ background: 'transparent', borderRadius: '300px', padding: "0.1rem 0.4rem", display: "flex", alignItems: "center", gap: "0.2rem" }}>
                  <img src={gold_coin} style={{ width: '18px', height: "18px" }} alt="coin" />
                  <span style={{ color: "#333" }}>{calculateTotalEarnings(item)}</span>
                </div>
                ,
              ];
            })}
          />

          <Grid container spacing={2} className={classes.pagination}>
            <div style={{ marginTop: '20px', textAlign: 'right', paddingRight: '20px', display: 'flex', gap: "10px" }}>
              <p>Total Coins to Claim Value: </p>
              <button className="claim-btn-shine" onClick={() => {
                handleClaimCoins();
              }}
              >
                <img src={gold_coin} style={{ width: '18px', height: "18px", marginRight: "4px" }} alt="coin" />
                <span>{overAllCheckedValue} Claim</span>
              </button>
            </div>
          </Grid>
          <Grid container spacing={2} className={classes.pagination}>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={count}
              rowsPerPage={10}
              page={page}
              onPageChange={handleChangePage}
            />
          </Grid>
        </Grid>

      </Grid>


      <Dialog
        aria-labelledby="dialog-title"
        onClose={handleModalClose}
        open={modalOpen}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogContent>
          <Grid container direction="row" spacing={2}>
            <div className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}>
              <Typography variant="subtitle2" className={classes.inputRoot}>
                Job Description
              </Typography>
              <div className={classes.pdfModalCloseBtn}>
                <CloseIcon className={classes.closeBtn} onClick={handleModalClose} />
              </div>
            </div>
            <Grid item xs={12}>
              {fileExtension === "pdf" ?
                <CustomPdfView resumeUrl={requirementsView?.jd} />
                :
                <div className={classes.iframediv} style={{ marginTop: "40px" }}>
                  <iframe
                    src={
                      "https://docs.google.com/a/umd.edu/viewer?url=" +
                      requirementsView?.jd +
                      "&embedded=true"
                    }
                    title="File"
                    width="100%" height="500" sandbox="allow-scripts allow-same-origin"
                  >
                  </iframe>
                  <div className={classes.iframeLogo} >
                  </div>
                </div>
              }
            </Grid>

            <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
              <Button variant="contained" size="small" color="secondary" onClick={handleModalClose}>
                Close
              </Button>
            </div>
          </Grid>
        </DialogContent>
      </Dialog>

      <AlertMessagePopup alertOpen={alertOpen} alertTitle={alertTitle} alertMessage={alertMessage} alertImage={alertImage} handleAlertClose={handleAlertClose} />

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <ToastContainer
        closeButton={
          <CloseButton className={classes.notificationCloseButton} />
        }
        closeOnClick={false}
        hideProgressBar={true}
      />
    </>
  );
}

function CloseButton({ closeToast, className }) {
  return <CloseIcon className={className} onClick={closeToast} />;
}
